export const SET_PATHS = 'SET_PATHS';
export const SET_CURRENT_PATH = 'SET_CURRENT_PATH';
export const ADD_PATH = 'ADD_PATH';
export const REMOVE_PATH = 'REMOVE_PATH';
export const UPDATE_PATH = 'UPDATE_PATH';
export const ADD_FLOW = 'ADD_FLOW';
